<template>
  <div>
    <section-page
      title="Pipeline Views"
      description=""
    >
      <template v-slot:right>
        <filter-link link-name="store" :link-params="{tab: 'pipelines'}">Get pipeline views from Store</filter-link>
        <button-outlined icon-left="plus" @click="$refs.pipelineViews.open()">
          New Pipeline View
        </button-outlined>
      </template>

      <table-default
        :table-data="pipelineViews"
        empty-message="You don't have any pipeline views.<br>Why don't you make one."
      >
        <b-table-column label="Name" field="label" v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column label="Description" field="description" v-slot="props">
          {{ props.row.description }}
        </b-table-column>

        <b-table-column label="# Statuses" numeric centered v-slot="props">
          {{ props.row.status_ids.length }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="200" v-slot="props">
          <button-link @click="$refs.pipelineViews.open(props.row)">Manage</button-link>
          <button-link :loading="isDuplicating" @click="duplicate(props.row.id)">Duplicate</button-link>
        </b-table-column>
      </table-default>
    </section-page>

    <modal-container>
      <modal-crud-form
        ref="pipelineViews"
        title="Pipeline View"
        form-component="pipeline-view-form"
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
export default {
  name: "PipelineViewSettings",
  data() {
    return {
      isDuplicating: false
    }
  },
  computed: {
    pipelineViews() {
      return this.$store.getters["pipeline/pipelineViews"];
    },
  },
  methods: {
    duplicate(viewId) {
      this.isDuplicating = true;
      this.$api.pipelineViews.clone(viewId)
        .then(res => {
          this.$buefy.toast.open({
            message: "Copied pipeline view",
            type: 'is-success'
          });

          this.$refs.pipelineViews.open(res.data);
        })
        .finally(() => this.isDuplicating = false);
    }
  },
}
</script>
